import { priorityToGradeLetter } from "./priorityToGradeLetter";

export default function percentToGradeLetter(percent: number) {
  const priority = 1 - percent;
  return priorityToGradeLetter(priority);
}
